<div>
  <button
    [disabled]="isSaveDisabled"
    (click)="onActionPreview()"
    class="btn btn--content-only"
  >
    <mat-icon class="mat-icon--preview">visibility</mat-icon>
  </button>
</div>
<div>
  <button
    (click)="onActionCancel()"
    class="btn btn--transparent"
    tabindex="-1"
    [mat-dialog-close]="false"
  >
    {{ "shared.cancel" | translate }}
  </button>
  <button
    class="btn btn--primary"
    tabindex="-1"
    (click)="onActionSave()"
    [disabled]="isSaveDisabled"
  >
    <span *ngIf="isSaving">{{ "shared.saving" | translate }}</span>
    <span *ngIf="!isSaving && !creationMode">{{
      "brand.campaign.contentCalendarPost.savePost" | translate
    }}</span>
    <span *ngIf="!isSaving && creationMode">{{
      "shared.create" | translate
    }}</span>
  </button>
</div>
